import React, { useState, useEffect } from 'react';
import ApiService from '../../services/api';
import {
    MonitorCog , SquareActivity , Tickets,  Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings,
    Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown,
    Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock,
    DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut,
    ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User,
    Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash,
    Grid, Cpu, Router, Network, HardDrive, Server, MonitorSpeaker,
    Radio, Wifi, Database, CircuitBoard, Power, PlugZap, UserCog, Calculator,
    Construction, Beaker, Leaf, ShieldCheck, Ruler, Square, Triangle,
    Hexagon, Maximize2, Move3D, Shapes, QrCode, Gauge, Anchor, Link, Folder , Receipt , Briefcase
} from 'lucide-react';
import '../../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../../assets/MEP_Solutions.png';
import architecturalIcon from '../../assets/architectural_icon.png';
import civilIcon from '../../assets/civil-icon.png';
import constructionIcon from '../../assets/construction-icon.png';
import powerToolsIcon from '../../assets/power-tools_icon.png';
import sustainableIcon from '../../assets/sustainable-icon.png';
import hygienicIcon from '../../assets/hygienic-icon.png';
import '../../Styles/dashboard.css';
import * as XLSX from 'xlsx';

const UnitechPipeClampsHangersPage = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('pipe-clamps-hangers');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('productId');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedPipeProduct, setSelectedPipeProduct] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categoryStats, setCategoryStats] = useState({});
    const [totalAllProducts, setTotalAllProducts] = useState(0);
    const navigate = useNavigate();

    const [pipeProducts, setPipeProducts] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        barcodeNumber: '',
        productId: '',
        description: '',
        standard: 'ASTM_A36',
        category: 'pipe_clamps_hangers'
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadPipeProducts();
            loadCategoryStats();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            setPagination(prev => ({ ...prev, page: 1 }));

            const timeoutId = setTimeout(() => {
                loadPipeProducts();
            }, searchTerm ? 300 : 100);

            return () => clearTimeout(timeoutId);
        }
    }, [user, searchTerm, sortBy, sortOrder, selectedCategory]);

    useEffect(() => {
        if (user && pagination.page) {
            console.log('Pipe clamps pagination page changed to:', pagination.page);
            loadPipeProducts();
        }
    }, [pagination.page]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);

            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadPipeProducts = async () => {
        try {
            setIsLoading(true);
            setError(null);

            const params = {
                search: searchTerm.trim() || undefined,
                category: selectedCategory || undefined,
                sortBy,
                sortOrder,
                page: pagination.page || 1,
                limit: 20
            };

            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            console.log('🔄 Loading pipe clamps & hangers products with params:', params);

            const response = await ApiService.getPipeClampsHangers(params);

            console.log('📡 Pipe Clamps & Hangers API Response:', response);

            if (response.success && response.products) {
                const productsArray = response.products || [];
                const paginationInfo = response.pagination || {};

                console.log('Pipe products found:', productsArray.length);
                console.log('Pagination info:', paginationInfo);

                setPipeProducts(productsArray);

                setPagination(prev => ({
                    ...prev,
                    total: paginationInfo.total || 0,
                    pages: paginationInfo.pages || 1,
                    limit: paginationInfo.limit || 20
                }));
            } else {
                console.error('Pipe Clamps & Hangers API Error:', response.message || 'Unknown error');
                setPipeProducts([]);
                setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
                setError(response.message || "Erreur lors du chargement des produits Pipe Clamps & Hangers");
            }
        } catch (error) {
            console.error('Load pipe products error:', error);
            setPipeProducts([]);
            setError(error.message || "Erreur lors du chargement des produits Pipe Clamps & Hangers");
            setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
        } finally {
            setIsLoading(false);
        }
    };

    const loadCategoryStats = async () => {
        try {
            const statsParams = {
                search: searchTerm.trim() || undefined,
            };

            Object.keys(statsParams).forEach(key => {
                if (statsParams[key] === undefined) {
                    delete statsParams[key];
                }
            });

            const response = await ApiService.getPipeClampsHangersStats(statsParams);
            if (response.success && response.stats) {
                const categoryBreakdown = response.stats.categoryBreakdown || {};
                setCategoryStats(categoryBreakdown);

                const total = Object.values(categoryBreakdown).reduce((sum, count) => sum + (count || 0), 0);
                setTotalAllProducts(total);
            }
        } catch (error) {
            console.error('Failed to load category stats:', error);
            setCategoryStats({});
            setTotalAllProducts(0);
        }
    };



    const handleRefresh = () => {
        loadPipeProducts();
        loadCategoryStats();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            standard: 'ASTM_A36',
            category: 'pipe_clamps_hangers'
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            standard: 'ASTM_A36',
            category: 'pipe_clamps_hangers'
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddPipeProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                standard: formData.standard,
                category: formData.category
            };

            const response = await ApiService.createPipeClampsHangers(productData);

            if (response.success) {
                alert('Produit Pipe Clamps & Hangers créé avec succès ! 🎉');
                closeAddModal();
                loadPipeProducts();
                loadCategoryStats();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la création du produit');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeletePipeProduct = async (productId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce produit Pipe Clamps & Hangers ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deletePipeClampsHangers(productId);
                if (response.success) {
                    loadPipeProducts();
                    loadCategoryStats();
                    alert('Produit Pipe Clamps & Hangers supprimé avec succès');
                }
            } catch (error) {
                console.error('Failed to delete pipe clamps & hangers product:', error);
                alert('Erreur lors de la suppression du produit: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            ApiService.clearUserData();
            navigate('/login');
        }
    };

    const menuItems = [
        {
            id: 'barcoding',
            label: 'Barcoding Database',
            icon: FileText,
            path: '/barcoding'
        },
        {
            id: 'mep-solutions',
            label: 'MEP Solutions',
            icon: MepIcon,
            isImage: true,
            path: '/mep_solutions'
        },
        {
            id: 'architectural-solutions',
            label: 'Architectural Solutions',
            icon: architecturalIcon,
            isImage: true,
            path: '/architectural_solutions'
        },
        {
            id: 'civil-solutions',
            label: 'Civil Solutions',
            icon: civilIcon,
            isImage: true,
            path: '/civil_solutions'
        },
        {
            id: 'construction-chemicals',
            label: 'Construction Chemicals',
            icon: constructionIcon,
            isImage: true,
            path: '/construction_chemicals'
        },
        {
            id: 'power-tools',
            label: 'Power & Industrial Tools',
            icon: powerToolsIcon,
            isImage: true,
            path: '/power_tools'
        },
        {
            id: 'sustainable-solutions',
            label: 'Sustainable Solutions',
            icon: sustainableIcon,
            isImage: true,
            path: '/sustainable_solutions'
        },
        {
            id: 'hygienic-solutions',
            label: 'Hygienic Solutions',
            icon: hygienicIcon,
            isImage: true,
            path: '/hygienic_solutions'
        },
        {
            id: 'conversions',
            label: 'Engineering Conversions',
            icon: Calculator,
            path: '/conversion'
        },
        {
            id: 'analytics',
            label: 'Amazon Products',
            icon: BarChart3,
            path: '/amazon_products'
        },
        {
            id: 'team',
            label: 'Team Management',
            icon: Users,
            path: '/team_management'
        },
        {
            id: 'user-management',
            label: 'User Management',
            icon: UserCog,
            path: '/users_management'
        },
    ];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const categoryOptions = [
        { value: 'pipe_clamps_hangers', label: 'Pipe Clamps & Hangers' },
        { value: 'support_system', label: 'Support System' },
        { value: 'threaded_accessories', label: 'Threaded Accessories' },
    ];

    const standardOptions = [
        'ASTM_A36', 'EN_10025', 'DIN_3015', 'BS_4504', 'ANSI_B16_5', 'MSS_SP_58'
    ];

    const getCategoryIcon = (categoryId) => {
        const iconMap = {
            'all': Grid,
            'pipe_clamps_hangers': Link,
            'support_system': Construction,
            'threaded_accessories': Wrench,
        };
        return iconMap[categoryId] || Package;
    };

    if (isAuthChecking) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    const openViewModal = (product) => {
        setSelectedPipeProduct(product);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedPipeProduct(null);
    };

    const openEditModal = (product) => {
        setSelectedPipeProduct(product);
        setFormData({
            barcodeNumber: product.barcodeNumber,
            productId: product.productId,
            description: product.description || '',
            standard: product.standard || 'ASTM_A36',
            category: product.category || 'pipe_clamps_hangers'
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedPipeProduct(null);
        setFormError('');
    };

    const handleEditPipeProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                standard: formData.standard,
                category: formData.category
            };

            const response = await ApiService.updatePipeClampsHangers(selectedPipeProduct._id, productData);

            if (response.success) {
                alert('Produit Pipe Clamps & Hangers mis à jour avec succès !');
                closeEditModal();
                loadPipeProducts();
                loadCategoryStats();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleExportPipeClampsHangers = async () => {
        try {
            setIsLoading(true);

            const exportScope = selectedCategory
                ? categoryOptions.find(c => c.value === selectedCategory)?.label || selectedCategory
                : 'All Categories';

            alert(`Preparing pipe clamps & hangers export for: ${exportScope}...`);

            const exportParams = {
                search: searchTerm.trim() || undefined,
                category: selectedCategory || undefined,
                sortBy,
                sortOrder,
                export: true,
                limit: 10000
            };

            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            console.log('Export params with category filter:', exportParams);

            const response = await ApiService.getPipeClampsHangers(exportParams);

            if (response.success || response.products || response.data) {
                let productsToExport = [];

                if (Array.isArray(response.products)) {
                    productsToExport = response.products;
                } else if (Array.isArray(response.data)) {
                    productsToExport = response.data;
                } else if (Array.isArray(response)) {
                    productsToExport = response;
                }

                const exportData = productsToExport.map((product, index) => ({
                    'No.': index + 1,
                    'Barcode Number': product.barcodeNumber || '',
                    'Product ID': product.productId || '',
                    'Category': categoryOptions.find(c => c.value === product.category)?.label || product.category || '',
                    'Standard': product.standard?.replace('_', ' ') || '',
                    'Description': product.description || '',
                    'Material': product.material || '',
                    'Size Range': product.sizeRange || '',
                    'Load Capacity': product.loadCapacity || '',
                    'Installation Method': product.installationMethod || '',
                    'Created Date': product.createdAt ? new Date(product.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                await exportPipeClampsHangersToExcel(exportData, productsToExport.length, exportScope);

            } else {
                throw new Error('No pipe clamps & hangers data to export');
            }
        } catch (error) {
            console.error('Pipe clamps & hangers export failed:', error);
            alert('Export failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const exportPipeClampsHangersToExcel = async (data, totalCount, exportScope) => {
        try {
            const ws = {};
            const headers = Object.keys(data[0] || {});

            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            const wb = {
                Sheets: { 'Pipe Clamps Hangers': ws },
                SheetNames: ['Pipe Clamps Hangers']
            };

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            const today = new Date().toISOString().split('T')[0];

            let filename;
            if (selectedCategory) {
                const categoryName = categoryOptions.find(c => c.value === selectedCategory)?.label || selectedCategory;
                const cleanCategoryName = categoryName.replace(/[^a-zA-Z0-9]/g, '-');
                filename = `UNITECH-Pipe-Clamps-Hangers_${cleanCategoryName}_${today}.xlsx`;
            } else {
                filename = `UNITECH-Pipe-Clamps-Hangers_All-Categories_${today}.xlsx`;
            }

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            alert(`Successfully exported ${totalCount} pipe clamps & hangers products (${exportScope}) to Excel! 🎉`);

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };

    const showNotification = (message, type = 'info', duration = 3000) => {
        console.log(`${type.toUpperCase()}: ${message}`);
    };

    return (
        <div className="dashboard-container">
            {}
            <style jsx>{`
                .categories-section {
                    margin-bottom: 32px;
                }

                .categories-title {
                    font-size: 24px;
                    font-weight: 700;
                    color: #1f2937;
                    margin-bottom: 24px;
                    border-bottom: 3px solid #3b82f6;
                    padding-bottom: 8px;
                    display: inline-block;
                }

                .categories-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 20px;
                    margin-bottom: 32px;
                }

                .category-card {
                    background: white;
                    border: 2px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 20px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .category-card:hover {
                    border-color: #3b82f6;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15);
                }

                .category-card.active {
                    border-color: #3b82f6;
                    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
                    color: white;
                }

                .category-icon {
                    width: 48px;
                    height: 48px;
                    background: #3b82f6;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 12px;
                    transition: all 0.3s ease;
                }

                .category-card.active .category-icon {
                    background: rgba(255, 255, 255, 0.2);
                }

                .category-name {
                    font-size: 16px;
                    font-weight: 600;
                    margin-bottom: 4px;
                    color: inherit;
                }

                .category-count {
                    font-size: 14px;
                    color: #6b7280;
                    font-weight: 500;
                }

                .category-card.active .category-count {
                    color: rgba(255, 255, 255, 0.8);
                }
            `}</style>

            {}
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '700px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#059669',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Link style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Add Pipe Clamps & Hangers Product
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Create a new pipe clamps & hangers product
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {}
                        <form onSubmit={showEditModal ? handleEditPipeProduct : handleAddPipeProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Numéro de Code-barres *
                                        </label>
                                        <input
                                            type="text"
                                            name="barcodeNumber"
                                            value={formData.barcodeNumber}
                                            onChange={handleInputChange}
                                            placeholder="1234567890123"
                                            required
                                            maxLength="13"
                                            pattern="[0-9]{13}"
                                            title="The barcode should be a 13-digit number."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text"
                                            name="productId"
                                            value={formData.productId}
                                            onChange={handleInputChange}
                                            placeholder="PCH-CLM-001"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Grid style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Category *
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {categoryOptions.map(category => (
                                                <option key={category.value} value={category.value}>
                                                    {category.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Shield style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Standard *
                                        </label>
                                        <select
                                            name="standard"
                                            value={formData.standard}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {standardOptions.map(standard => (
                                                <option key={standard} value={standard}>
                                                    {standard.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <FileText style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Description *
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Detailed description of the pipe clamps & hangers product."
                                        required
                                        rows="4"
                                        maxLength="1000"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>

                            {}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginTop: '24px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={showEditModal ? closeEditModal : closeAddModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px 20px',
                                        border: '1px solid #d1d5db',
                                        background: 'white',
                                        color: '#374151',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2,
                                        padding: '12px 20px',
                                        border: 'none',
                                        background: isSubmitting ? '#9ca3af' : (showEditModal ? '#f59e0b' : '#059669'),
                                        color: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            {showEditModal ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                        <>
                                            <Link style={{ width: '16px', height: '16px' }} />
                                            {showEditModal ? 'Update' : 'Create Product'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {}
            {showViewModal && selectedPipeProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        {}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#0ea5e9',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Pipe Clamps & Hangers Details
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedPipeProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {}
                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE-BARRES</label>
                                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                                        {selectedPipeProduct.barcodeNumber}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRODUCT ID</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedPipeProduct.productId}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CATEGORY</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {categoryOptions.find(c => c.value === selectedPipeProduct.category)?.label || selectedPipeProduct.category}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STANDARD</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedPipeProduct.standard?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                    {selectedPipeProduct.description}
                                </p>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CREATED ON</label>
                                <p style={{ margin: 0, fontSize: '14px' }}>
                                    {selectedPipeProduct.createdAt ? new Date(selectedPipeProduct.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
                                </p>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {}
            {showEditModal && selectedPipeProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Produit Pipe Clamps & Hangers
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedPipeProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {}
                        <form onSubmit={handleEditPipeProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Barcode Number *
                                        </label>
                                        <input
                                            type="text" name="barcodeNumber" value={formData.barcodeNumber} onChange={handleInputChange} required
                                            maxLength="13" pattern="[0-9]{13}"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text" name="productId" value={formData.productId} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                {}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Category *
                                        </label>
                                        <select name="category" value={formData.category} onChange={handleInputChange} required
                                                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {categoryOptions.map(category => (
                                                <option key={category.value} value={category.value}>{category.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Standard *
                                        </label>
                                        <select name="standard" value={formData.standard} onChange={handleInputChange} required
                                                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {standardOptions.map(standard => (
                                                <option key={standard} value={standard}>{standard.replace('_', ' ')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {}
                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description *
                                    </label>
                                    <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="4" maxLength="1000"
                                              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>
                            {}
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                        style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                        style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div
                        className="sidebar-logo-container"
                        onClick={() => navigate('/dashboard')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '8px',
                            padding: '8px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                        title="Retour au Dashboard"
                    >
                        <div className="sidebar-logo">
                            <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                        </div>
                        <div className="sidebar-brand">
                            <h1 className="sidebar-title">UNITECH IKK</h1>
                            <p className="sidebar-subtitle">Enterprise Dashboard</p>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {filteredMenuItems.map((item) => (
                        <div
                            key={item.id}
                            className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
                            onClick={() => {
                                setActiveMenuItem(item.id);
                                navigate(item.path);
                            }}
                        >
                            {item.isImage ? (
                                <img
                                    src={item.icon}
                                    alt={item.label}
                                    className="nav-icon-image"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <item.icon
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            )}
                            <span className="nav-text">{item.label}</span>
                        </div>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {}
            <main className="main-content">
                {}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Link style={{ width: '16px', height: '16px' }} />
                                    <span>Pipe Clamps & Hangers</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Products</span>
                                </div>
                            </nav>
                        </div>

                        <div className="header-right">
                            <div className="search-container">
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Research..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                            </div>

                            <div className="header-actions">
                                <button
                                    className="header-button"
                                    onClick={handleRefresh}
                                    disabled={isLoading}
                                    title="Actualiser"
                                >
                                    <RefreshCw style={{
                                        width: '18px',
                                        height: '18px',
                                        transform: isLoading ? 'rotate(360deg)' : 'none',
                                        transition: 'transform 1s linear'
                                    }} />
                                </button>

                                <button
                                    className="header-button"
                                    title="Notifications"
                                >
                                    <Bell style={{ width: '18px', height: '18px' }} />
                                    {notifications > 0 && (
                                        <span className="notification-badge">{notifications}</span>
                                    )}
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/settings')}
                                    title="Paramètres système"
                                >
                                    <Settings style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/project_management')}
                                    title="Gestion de projets"
                                >
                                    <Folder style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/technical_support')}
                                    title="Technical Support"
                                >
                                    <MonitorCog style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/admin_support_it')}
                                    title="Admin Support IT"
                                >
                                    <SquareActivity style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/mytickets')}
                                    title="My Tickets"
                                >
                                    <Tickets style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/quotations')}
                                    title="Quotation System"
                                >
                                    <Receipt style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/clients')}
                                    title="Clients"
                                >
                                    <Briefcase style={{ width: '18px', height: '18px' }} />
                                </button>s

                                <div className="time-display">
                                    {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {}
                <div className="products-content">
                    {}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {}
                    <div className="page-header">
                        <h1 className="page-title">Pipe Clamps & Hangers With Accessories</h1>
                        <p className="page-subtitle">
                            Manage your UNITECH IKK pipe clamps & hangers inventory - Professional piping support systems for secure installations.
                        </p>

                        <div className="page-actions">
                            <button
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <Link style={{ width: '16px', height: '16px' }} />
                                Add Pipe Product
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportPipeClampsHangers}
                                disabled={isLoading}
                                title="Export all pipe clamps & hangers products"
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Export Catalogue
                            </button>
                            <button className="action-button secondary">
                                <ShoppingCart style={{ width: '16px', height: '16px' }} />
                                Quick Order
                            </button>
                        </div>
                    </div>

                    {}
                    <div className="categories-section">

                        <div className="categories-grid">
                            {}
                            <div
                                className={`category-card ${selectedCategory === '' ? 'active' : ''}`}
                                onClick={() => setSelectedCategory('')}
                            >
                                <div className="category-icon">
                                    <Grid style={{ width: '24px', height: '24px', color: 'white' }} />
                                </div>
                                <div className="category-name">Tous les produits</div>
                                <div className="category-count">{totalAllProducts} produits</div>
                            </div>

                            {}
                            <div
                                className={`category-card ${selectedCategory === 'pipe_clamps_hangers' ? 'active' : ''}`}
                                onClick={() => setSelectedCategory('pipe_clamps_hangers')}
                            >
                                <div className="category-icon">
                                    <Link style={{ width: '24px', height: '24px', color: 'white' }} />
                                </div>
                                <div className="category-name">Pipe Clamps & Hangers</div>
                                <div className="category-count">{categoryStats.pipe_clamps_hangers || 0} produits</div>
                            </div>

                            {}
                            <div
                                className={`category-card ${selectedCategory === 'support_system' ? 'active' : ''}`}
                                onClick={() => setSelectedCategory('support_system')}
                            >
                                <div className="category-icon">
                                    <Construction style={{ width: '24px', height: '24px', color: 'white' }} />
                                </div>
                                <div className="category-name">Support System</div>
                                <div className="category-count">{categoryStats.support_system || 0} produits</div>
                            </div>

                            {}
                            <div
                                className={`category-card ${selectedCategory === 'threaded_accessories' ? 'active' : ''}`}
                                onClick={() => setSelectedCategory('threaded_accessories')}
                            >
                                <div className="category-icon">
                                    <Wrench style={{ width: '24px', height: '24px', color: 'white' }} />
                                </div>
                                <div className="category-name">Threaded Accessories</div>
                                <div className="category-count">{categoryStats.threaded_accessories || 0} produits</div>
                            </div>
                        </div>
                    </div>

                    {}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Product ID, barcode, description, category..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="productId">Product ID</option>
                                    <option value="barcodeNumber">Barcode</option>
                                    <option value="category">Category</option>
                                    <option value="standard">Standard</option>
                                    <option value="updatedAt">Last Updated</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                Tous les produits Pipe Clamps & Hangers
                            </h2>
                            <span className="table-stats">
                           {pagination.total} produit{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                       </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                            <tr>
                                <th onClick={() => {
                                    setSortBy('barcodeNumber');
                                    setSortOrder(sortBy === 'barcodeNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Code-barres {sortBy === 'barcodeNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('productId');
                                    setSortOrder(sortBy === 'productId' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Product ID {sortBy === 'productId' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('category');
                                    setSortOrder(sortBy === 'category' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Category {sortBy === 'category' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Description</th>
                                <th onClick={() => {
                                    setSortBy('standard');
                                    setSortOrder(sortBy === 'standard' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Standard {sortBy === 'standard' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('updatedAt');
                                    setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody className="table-body">
                            {pipeProducts.map((product) => {
                                const CategoryIcon = getCategoryIcon(product.category);
                                return (
                                    <tr key={product._id}>
                                        <td>
                                            <div className="barcode-info">
                                                <div className="barcode-number" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                    {product.barcodeNumber}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <div className="product-name" style={{ fontWeight: '500' }}>
                                                    {product.productId}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                           <span className="category-badge" style={{
                                               backgroundColor: '#e0f2fe',
                                               color: '#0277bd',
                                               padding: '4px 8px',
                                               borderRadius: '4px',
                                               fontSize: '12px',
                                               fontWeight: '500',
                                               display: 'flex',
                                               alignItems: 'center',
                                               gap: '6px',
                                               width: 'fit-content'
                                           }}>
                                               <CategoryIcon style={{ width: '14px', height: '14px' }} />
                                               {categoryOptions.find(c => c.value === product.category)?.label || product.category}
                                           </span>
                                        </td>
                                        <td>
                                            <div className="description-cell" style={{
                                                maxWidth: '300px',
                                                whiteSpace: 'normal',
                                                lineHeight: '1.5',
                                                wordBreak: 'break-word',
                                                fontSize: '13px',
                                                padding: '4px 0'
                                            }}>
                                                {product.description}
                                            </div>
                                        </td>
                                        <td>
                                           <span className="standard-badge" style={{
                                               backgroundColor: '#f3f4f6',
                                               color: '#374151',
                                               padding: '4px 8px',
                                               borderRadius: '4px',
                                               fontSize: '12px',
                                               fontWeight: '500'
                                           }}>
                                               {product.standard?.replace('_', ' ') || 'N/A'}
                                           </span>
                                        </td>
                                        <td>
                                            {product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : '-'}
                                        </td>
                                        <td>
                                            <div className="actions-cell">
                                                <button
                                                    className="action-icon"
                                                    title="Voir détails"
                                                    onClick={() => openViewModal(product)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Eye style={{ width: '16px', height: '16px' }} />
                                                </button>
                                                {(user.role === 'manager' || user.role === 'admin') && (
                                                    <button
                                                        className="action-icon edit"
                                                        title="Modifier"
                                                        onClick={() => openEditModal(product)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Edit style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                                {user.role === 'admin' && (
                                                    <button
                                                        className="action-icon delete"
                                                        title="Supprimer"
                                                        onClick={() => handleDeletePipeProduct(product._id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        {pipeProducts.length === 0 && !isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <Link style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucun produit Pipe Clamps & Hangers trouvé
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Essayez de modifier vos critères de recherche ou filtres, ou ajoutez de nouveaux produits UNITECH Pipe.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '0 auto 16px',
                                    animation: 'spin 1s linear infinite'
                                }} />
                                <p>Chargement des produits Pipe Clamps & Hangers...</p>
                            </div>
                        )}

                        {}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '15px',
                                flexWrap: 'wrap',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                {}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                                    disabled={pagination.page === 1}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === 1 ? '#f9fafb' : 'white',
                                        color: pagination.page === 1 ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <ChevronRight style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }} />
                                    Précédent
                                </button>

                                {}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    {pagination.page > 3 && (
                                        <>
                                            <button
                                                onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: 'white',
                                                    color: '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                1
                                            </button>
                                            {pagination.page > 4 && (
                                                <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                                            )}
                                        </>
                                    )}

                                    {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                                        .filter(page =>
                                            page >= Math.max(1, pagination.page - 2) &&
                                            page <= Math.min(pagination.pages, pagination.page + 2)
                                        )
                                        .map(page => (
                                            <button
                                                key={page}
                                                onClick={() => setPagination(prev => ({ ...prev, page }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: page === pagination.page ? '#1e40af' : 'white',
                                                    color: page === pagination.page ? 'white' : '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: page === pagination.page ? '600' : '500',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (page !== pagination.page) {
                                                        e.target.style.backgroundColor = '#e5e7eb';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (page !== pagination.page) {
                                                        e.target.style.backgroundColor = 'white';
                                                    }
                                                }}
                                            >
                                                {page}
                                            </button>
                                        ))
                                    }

                                    {pagination.page < pagination.pages - 2 && (
                                        <>
                                            {pagination.page < pagination.pages - 3 && (
                                                <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                                            )}
                                            <button
                                                onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: 'white',
                                                    color: '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                {pagination.pages}
                                            </button>
                                        </>
                                    )}
                                </div>

                                {}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <QrCode style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                    <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                                   Aller à:
                               </span>
                                    <input
                                        type="number"
                                        min="1"
                                        max={pagination.pages}
                                        placeholder={pagination.page}
                                        style={{
                                            width: '60px',
                                            padding: '4px 8px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '4px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            outline: 'none'
                                        }}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                const page = parseInt(e.target.value);
                                                if (page >= 1 && page <= pagination.pages) {
                                                    setPagination(prev => ({ ...prev, page }));
                                                    e.target.value = '';
                                                    showNotification(`Navigation vers la page ${page}`, 'info', 2000);
                                                } else {
                                                    showNotification('Numéro de page invalide', 'error', 3000);
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const page = parseInt(e.target.value);
                                            if (page >= 1 && page <= pagination.pages) {
                                                setPagination(prev => ({ ...prev, page }));
                                            }
                                            e.target.value = '';
                                        }}
                                    />
                                    <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                   sur {pagination.pages}
                               </span>
                                </div>

                                {}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
                                    disabled={pagination.page === pagination.pages}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                                        color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    Suivant
                                    <ChevronRight style={{ width: '14px', height: '14px' }} />
                                </button>
                            </div>
                        )}

                        {}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '16px 20px',
                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: '14px',
                                color: '#6b7280'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Database style={{ width: '16px', height: '16px' }} />
                                    <span>
                                   Affichage de {((pagination.page - 1) * pagination.limit) + 1} à {Math.min(pagination.page * pagination.limit, pagination.total)}
                                        sur {pagination.total} codes-barres
                               </span>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    fontSize: '12px'
                                }}>
                               <span style={{
                                   backgroundColor: '#e5e7eb',
                                   padding: '2px 6px',
                                   borderRadius: '4px',
                                   fontWeight: '500'
                               }}>
                                   {pagination.limit} par page
                               </span>
                                    <span>•</span>
                                    <span>Page {pagination.page}/{pagination.pages}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechPipeClampsHangersPage;